/**
 * API Configuration
 * Central configuration for API endpoints
 * 
 * Configuration is loaded from environment variables:
 * - VITE_API_BASE_URL: Base URL for the API (e.g., "https://dev.slipaj.com/api/v3")
 * 
 * To change the API URL, update the corresponding .env file:
 * - .env.development (for local development)
 * - .env.production (for production build)
 */

export const API_CONFIG = {
  /**
   * Base URL for the API
   * Loaded from environment variable VITE_API_BASE_URL
   * Falls back to development URL if not set
   */
  BASE_URL:  "https://slipaj.com",
  
  /**
   * API Version
   */
  VERSION: "3.0.0",
} as const

/**
 * Get full API URL by appending endpoint path to base URL
 * @param endpoint - The endpoint path (e.g., "/verify/qr-code")
 * @returns Full API URL
 */
export function getApiUrl(endpoint: string): string {
  // Remove leading slash if present to avoid double slashes
  const cleanEndpoint = endpoint.startsWith("/") ? endpoint.slice(1) : endpoint
  return `${API_CONFIG.BASE_URL}/${cleanEndpoint}`
}
